import { asyncActionCreators } from '../../utils/actions';

export const fetchReports = asyncActionCreators('Dashboard/FETCH_REPORTS');
export const fetchReportsByDate = asyncActionCreators('Dashboard/FETCH_REPORTS_BY_DATE');
export const fetchLeftCostReports = asyncActionCreators('Dashboard/FETCH_LEFT_COST_REPORTS');
export const fetchRightCostReports = asyncActionCreators('Dashboard/FETCH_RIGHT_COST_REPORTS');
export const fetchLastJourney = asyncActionCreators('Dashboard/FETCH_LAST_JOURNEY');



// WEBPACK FOOTER //
// ./src/sagas/dashboard/actions.js